import React from "react";
import { FlexBetween } from "../../../layout/FlexBetween/FlexBetween";
import { FlexCenter } from "../../../layout/FlexCenter/FlexCenter";
import { ExecButton } from "../../../ui/ExecButton/ExecButton";
import { TDisplay } from "../../../../interface/interfaces";
import { setDashboardListDisplay } from "./dashboardListDisplay.slice";
import { useDispatch } from "react-redux";
import { Spacing } from "../../../layout/Spacing/Spacing";
import { Button } from "../../../ui/Button";
import { setDashboardNodeType } from "./DashboardNodeType.slice";
import { useAppSelector } from "../../../../redux/hooks";

interface IDashboardFilterProps {
    display: TDisplay,
    position?: 'absolute' | 'relative',
    hasAnimated?: boolean,
    showElem?: boolean,
    func: ()=>void
}

export const DashboardFilter: React.FC<IDashboardFilterProps> = ({display, position, hasAnimated = false, showElem = true, func}) => {

    const dispatch = useDispatch();
    const {dashboardNodeType} = useAppSelector((state)=>state.dashboardNodeType);

    const setDisplay = (display: TDisplay) => {
        dispatch(setDashboardListDisplay(display));
    }

    const content = (
        <FlexBetween>
            <FlexCenter direction="v" gap={.5}>
                <ExecButton textColor="grey-dark" showLabel = {dashboardNodeType === "tree" ? true : false} label={"Tree nodes"} iconName={"Tree_node"} func={()=>dispatch(setDashboardNodeType("tree"))}/>
                <ExecButton textColor="grey-dark" showLabel = {dashboardNodeType === "inBox"  ? true : false} label={"InBox nodes"} iconName={"InBox_node"} func={()=>dispatch(setDashboardNodeType("inBox"))}/>
            </FlexCenter>
            <FlexCenter direction="v" position="end" gap={2}>
                <FlexCenter direction="v" gap={.5}>
                    <ExecButton textColor="grey-dark" showLabel = {display === 'row' ? true : false} label={"Row"} iconName={"Row"} func={()=>setDisplay('row')}/>
                    <ExecButton textColor="grey-dark" showLabel = {display === 'grid' ? true : false} label={"Grid"} iconName={"Grid"} func={()=>setDisplay('grid')}/>
                </FlexCenter>
                <ExecButton textColor="grey-dark" showLabel = {true} label={"Filter"} iconName={"Filter"} func={func}/>
            </FlexCenter>
        </FlexBetween>
        )
    
    return (
        <>
            {
                position === 'absolute'
                ?
                <div className={`dashboard-filter-nav-absolute dashboard-filter-nav-${hasAnimated ? 'show' : 'hide'}`} style={{display: showElem ? 'block' : 'none'}}>
                    <Spacing paddingSpacing="m" marginSpacing="none">
                        {content} 
                    </Spacing>
                </div>
                :
                content
            }
        </>
    )

}